export const logo = `${process.env.PUBLIC_URL}/images/logo.png`;
export const avatar = `${process.env.PUBLIC_URL}/images/avatar.jpg`;
export const banner = `${process.env.PUBLIC_URL}/images/banner.png`;
//export const bg_geocrm = `${process.env.PUBLIC_URL}/images/bg_geocrm.jpg`; 
export const illustrator_warning = `${process.env.PUBLIC_URL}/images/warning_re_eoyh.svg`; 